"use client";

import React, { useId, useState } from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import { useRouter } from "next/navigation";
import Kicker from "@/src/components/common/broadsheet/kicker";
import { FONT_TEXT, FONT_UI } from "@/src/components/common/broadsheet/tokens";

const SEARCH_PARTS = "title,keywords,authors,abstract";

export default function SearchBar() {
  const router = useRouter();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const inputId = useId();

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    const term = searchTerm.trim();
    if (!term) return;
    router.push(
      `/search?search_term=${encodeURIComponent(term)}&search_parts=${SEARCH_PARTS}`,
    );
  };

  return (
    <Box
      component="form"
      role="search"
      action="/search"
      method="get"
      onSubmit={submit}
    >
      <Kicker
        component="label"
        htmlFor={inputId}
        sx={{ display: "block", mb: 0.25 }}
      >
        Search the archive
      </Kicker>
      <Box sx={{ display: "flex", alignItems: "stretch", gap: 0.375 }}>
        <TextField
          id={inputId}
          name="search_term"
          fullWidth
          size="small"
          placeholder="Authors, abstracts, keywords, DOI…"
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              fontFamily: FONT_TEXT,
              fontSize: "0.9375rem",
              borderRadius: 0,
              backgroundColor: "custom.newsprintRaised",
              "& fieldset": {
                borderColor: "custom.ruleHairline",
                borderBottomWidth: "2px",
                borderBottomColor: "primary.main",
              },
              "&:hover fieldset, &.Mui-focused fieldset": {
                borderColor: "primary.main",
              },
            },
            "& input::placeholder": {
              fontFamily: FONT_UI,
              fontSize: "0.8125rem",
              opacity: 0.85,
            },
          }}
        />
        <input type="hidden" name="search_parts" value={SEARCH_PARTS} />
        <Box
          component="button"
          type="submit"
          sx={{
            fontFamily: FONT_UI,
            fontSize: "0.8125rem",
            fontWeight: 600,
            px: 1.25,
            border: "1px solid",
            borderColor: "primary.main",
            backgroundColor: "primary.main",
            color: "custom.inverted",
            cursor: "pointer",
            flex: "none",
            "&:hover": {
              backgroundColor: "custom.linkHover",
              borderColor: "custom.linkHover",
            },
          }}
        >
          Search
        </Box>
      </Box>
    </Box>
  );
}
